import {
    Injectable
}
from '@angular/core';
import {
    Store
}
from '@ngrx/store';
import {
    AppState
}
from '../app.state';
import * as NewMembersAction from './newMembers.actions';
import { IActiveTab, NewMemberState } from './newMembers.state';
import { Observable, map } from 'rxjs';
import { GameStateId } from '../game/game.state';


@Injectable()
export class NewMemberStoreDispatcher {


    constructor(
        private store: Store < AppState > ,
    ) {}


    goToRequests(gameStateId: GameStateId) {
        this.store.dispatch(NewMembersAction.displayRequestsAction({ gameStateId }));
    }

    goToCounter(gameStateId: GameStateId) {
        this.store.dispatch(NewMembersAction.displayCounterAction({ gameStateId }));
    }

    goToInfo(gameStateId: GameStateId) {
        this.store.dispatch(NewMembersAction.displayInfoAction({ gameStateId }));
    }


    /** Returns an Observable of non-null GameStates */
    public getState(gameStateId: GameStateId): Observable < IActiveTab > {
        return this.store.select((state: AppState) => state.newMembers).pipe(
            map(membersState => membersState[gameStateId]),
        );
    }
}
